<template>
    <div class="inline-switch">
        <div class="value-container" @click="toggleShowOptions">
            <div :class="{ 'selected-value': true, 'highlight': selectedValue != null }">{{selectedValue != null ? selectedValue.caption : "N/A"}}</div>
            <div class="selection-caret"><icon :icon="['fas', 'caret-down']"/></div>
        </div>
        <div ref="selectionList" :class="{ 'options-container': true, 'show-options-container': this.showOptions }">
            <div class="option" @click="selectValue(null)">
                N/A
            </div>
            <div v-for="option in options" @click="selectValue(option)" class="option">
                {{option.caption}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InlineSwitch",
        props: {
            options: Array,
            value: String
        },
        data() {
            return {
                selectedValue: null,
                showOptions: false
            }
        },
        methods: {
            selectValue(option) {
                this.selectedValue = option;
                this.showOptions = false;

                this.$emit('input', option?.value ?? "");
                this.$emit('selected', option?.value ?? "");

            },
            toggleShowOptions() {
                this.showOptions = !this.showOptions;
                if(this.showOptions) {
                    window.addEventListener('mousedown', e => {
                        this.blurSelectionBox(e);
                    })
                }
            },
            blurSelectionBox(e) {
                if(e.target.parents(this.$refs.selectionList)) {
                    return;
                }
                this.showOptions = false;
                window.removeEventListener("mousedown", this.blurSelectionBox);
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    if(newVal == '') {
                        this.selectedValue = null;
                    }
                    else {
                        this.$set(this, 'selectedValue', this.options.find(opt => opt.value == newVal));
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .inline-switch {
        margin-left: 2px;
    }
    .value-container {
        & > * {
            display: flex;
            justify-content: center;
            align-items: center;
            justify-items: center;
            align-content: center;

        }
        display: flex;
        flex-flow: row;
        height: 100%;
        background-color: transparent;
    }

    .options-container {
        display: none;
        background-color: var(--input-background-color);
        border-left: 1px solid var(--input-border-color);
        border-right: 1px solid var(--input-border-color);
        border-bottom: 1px solid var(--input-border-color);
        position: absolute;
        top: 1.7em;
        z-index: 10;
    }

    .show-options-container {
        display: flex;
        flex-flow: column;

    }

    .selected-value {
        color: var(--input-font-color);

        padding: 0px 10px 0px 10px;
    }

    .highlight {
        color: var(--background-color);
        background: linear-gradient(to bottom, #ffaf34 5%, #ffe98e 100%);
        border-radius: 2px;
    }

    .selection-caret {
        padding-left: 5px;
    }

    .option {
        padding: 5px 10px 5px 10px;
        width: 100%;
    }

    .option:hover {
        background-color: var(--accent-color);
        color: var(--input-active-font-color);
        cursor: pointer;
    }
</style>